<template>
    <div class="chat-container">
        <div class="messages-area" ref="messagesArea" tabindex="0">
            <div v-for="(message, index) in messages" :key="index"
                :class="['message', message.sender, isShort(message) ? 'short' : 'long']">
                <div class="message-content">
                    <span v-html="messageHandler(message.text)"></span>
                </div>
                <div class="message-time">
                    {{ formatTime(message.timestamp) }}
                </div>
                <div style="position: absolute; margin-top: 12px;">
                    <div class="message_helpers" @click="copyText(message.text, index)">
                        <i class="fa-solid fa-copy" v-if="copyBtnId !== index"></i>
                        <i class="fas fa-clipboard" v-else></i>
                    </div>

                </div>


            </div>
            <div class="message ai" v-if="isTyping">
                <div class="message-content">
                    <div class="typing-dots">
                        <span><i class="fa-solid fa-circle"></i></span>
                        <span><i class="fa-solid fa-circle"></i></span>
                        <span><i class="fa-solid fa-circle"></i></span>
                    </div>
                </div>
            </div>
            <hr id="chat_end" tabindex="-1" style="margin-top: 20px;">
        </div>

        <div class="message-input-area">
            <input v-model="newMessage" @keyup.enter="sendMessage"
                :placeholder="this.sendBtn == 'connected' ? 'Write a message...' : sendBtn" class="message-input"
                :disabled="this.sendBtn != 'connected'" />
            <button @click="sendMessage" class="send-button" v-if="sendBtn == 'connected'">
                <i class="fas fa-paper-plane" style="font-size: 1rem;"> </i>
            </button>
            <button @click="BotOnline" class="send-button" v-if="sendBtn == 'connect'">
                <i class="fas fa-plug" style="font-size: 1rem;"> </i>
            </button>
            <button @click="BotOnline" class="send-button" v-if="sendBtn == 'connecting'">
                <i class="fa-solid fa-spinner fa-spin-pulse" style="font-size: 1rem;"> </i>
            </button>
            <button @click="BotOnline" class="send-button" v-if="sendBtn == 'diconnected'">
                <i class="fas fa-unlink" style="font-size: 1rem;"> </i>
            </button>
        </div>
    </div>
</template>

<script>
import { PostRequest } from '@/network'

export default {
    name: 'ChatMessages',
    data() {
        return {
            newMessage: '',
            messages: [
                {
                    text: 'Hello! How can I help you today?',
                    sender: 'ai',
                    timestamp: new Date()
                }
            ],
            BotHelth: null,
            sendBtn: 'connect',
            isTyping: false,

            copyBtn: true,
            copyBtnId: -1,

            devConsole: false
        }
    },
    methods: {
        isShort(message) {
            return message.text.length <= 0;
        },
        async sendMessage() {
            if (this.sendBtn == 'connected') {
                if (this.newMessage.trim() === '') return;

                // Push user message and scroll
                this.messages.push({
                    text: this.newMessage,
                    sender: 'user',
                    timestamp: new Date()
                });

                this.isTyping = true;
                await this.$nextTick();
                this.focusChat();

                try {
                    const result = await PostRequest('/generate', { prompt: this.newMessage }, 'ai_chat');
                    this.newMessage = '';

                    setTimeout(async () => {
                        if (!result?.data?.Data || typeof result?.data?.Data !== 'string') {
                            this.messages.push({
                                text: '<span style="color:red;">Error: AI returned no message.</span>',
                                sender: 'ai',
                                timestamp: new Date()
                            });
                            this.BotOnline();
                        } else {
                            this.messages.push({
                                text: result?.data?.Data,
                                sender: 'ai',
                                timestamp: new Date()
                            });
                        }

                        await this.$nextTick();
                        this.focusChat();
                        this.isTyping = false;
                    }, 1000);
                } catch (error) {
                    this.devConsole && console.error('AI Request Failed:', error);
                    this.messages.push({
                        text: '<span style="color:red;">AI bot failed to respond. Please try again later.</span>',
                        sender: 'ai',
                        timestamp: new Date()
                    });
                    this.isTyping = false;
                }
            } else {
                this.devConsole && console.log("Bot not connected!");
            }
        },
        messageHandler(message) {
            if (!message || typeof message !== 'string') {
                return '<span style="color:red;">[Invalid AI response]</span>';
            }
            return message
                .replace(/<PAD>/g, '<span style="color: gray;">[PAD]</span>')
                .replace(/<UNK>/g, '<span style="color: red;">[UNK]</span>')
                .replace(/<START>/g, '<span style="color: green;">[START]</span>')
                .replace(/<END>/g, '<span style="color: blue;">[END]</span>');
        }
        ,
        focusChat() {
            const el = document.getElementById(`chat_end`);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
                el.focus();
            }
        },
        scrollToBottom() {
            const container = this.$refs.messagesArea
            container.scrollTop = container.scrollHeight
        },
        formatTime(date) {
            return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        },
        async BotOnline() {
            this.sendBtn = "connecting";
            const result = await PostRequest('/health', null, 'ai_chat');
            if (
                result?.data?.StatusCode === 200 &&
                result?.data?.status === 'SUCCESS' &&
                result?.data?.Data?.helth === 'healthy' &&
                result?.data?.Data?.model_initialized === true &&
                result?.data?.Data?.tokenizer_initialized === true
            ) {
                this.sendBtn = 'connected';
                return true;
            } else {
                this.sendBtn = 'diconnected';
                return false;
            }
        },
        copyText(text, id) {
            const temp = document.createElement("textarea");
            temp.value = text;
            document.body.appendChild(temp);
            temp.select();
            document.execCommand("copy");
            document.body.removeChild(temp);

            // Show the "clipboard" icon temporarily
            this.copyBtnId = id;
            setTimeout(() => {
                this.copyBtnId = -1;
            }, 1500); // Reset after 1.5 seconds
        }
    },
    mounted() {
        this.BotOnline().then(botResponce => {
            if (botResponce) {
                this.sendBtn = 'connected';
            } else {
                this.sendBtn = 'connect'
            }
        });
    }
}
</script>

<style scoped>
.typing-dots {
    display: flex;
    font-size: 10px;
    letter-spacing: 3px;
}

.typing-dots span {
    animation: blink 1.4s infinite both;
}

.typing-dots span:nth-child(2) {
    animation-delay: 0.2s;
}

.typing-dots span:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes blink {
    0% {
        opacity: 0.2;
        transform: translateY(0px);
    }

    20% {
        opacity: 1;
        transform: translateY(-10px);
    }

    100% {
        opacity: 0.2;
        transform: translateY(0px);
    }
}

.message-content {
    text-align: left;
}

.chat-container {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 200px);
    /* max-width: 400px; */
    width: 100%;
    margin: 0 auto;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

.messages-area {
    flex: 1;
    padding: 16px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.message {
    max-width: 80%;
    padding: 12px 16px;
    border-radius: 18px;
    line-height: 1.4;
    position: relative;
    display: block;
}

.message.short {
    background-color: aqua;
    display: flex;
}

.message.long {
    background-color: rgb(123, 255, 0);
    display: block;
}

.message.user {
    align-self: flex-end;
    background: #6e8efb;
    color: white;
    border-bottom-right-radius: 4px;
}

.message.ai {
    align-self: flex-start;
    background: #f3f4f6;
    color: #111827;
    border-bottom-left-radius: 4px;
}

.message-time {
    font-size: 0.7rem;
    margin-top: 4px;
    opacity: 0.8;
    text-align: right;
    padding-left: 10px;
}

.message-input-area {
    display: flex;
    padding: 12px;
    background: #f9fafb;
    border-top: 1px solid #e5e7eb;
}

.message-input {
    flex: 1;
    padding: 12px 16px;
    border: 1px solid #e5e7eb;
    border-radius: 24px;
    font-size: 0.95rem;
    outline: none;
    transition: border-color 0.2s;
}

.message-input:focus {
    border-color: #6e8efb;
}

.message_helpers {
    color: darkgray;
}

.send-button {
    background: #6e8efb;
    color: white;
    border: none;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    margin-left: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s;
}

.send-button:hover {
    background: #5a7df4;
}

.send-button svg {
    stroke: white;
}
</style>